import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { styles } from './RegistrationHeader.styles';

export function RegistrationHeader() {
  const t = useTranslations();
  const slots = styles();

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{t('registration.title')}</h2>
      <p className={slots.description()}>{t('registration.description')}</p>
      <div className={slots.decoration()}>
        <Image
          src="/images/registration-decoration.webp"
          alt=""
          width={383}
          height={367}
          className={slots.decorationImage()}
        />
      </div>
    </div>
  );
}
